// Load static fonts
import 'typeface-merriweather';

export { default as onInitialClientRender } from './src/gatsby/browser/onInitialClientRender';
export { default as onRouteUpdate } from './src/gatsby/browser/onRouteUpdate';
export { default as shouldUpdateScroll } from './src/gatsby/browser/shouldUpdateScroll';
